import PropTypes from 'prop-types';
import PantherIcon from './PantherIcon';
import ReactIcon from './ReactIcon';
import './style.scss';
import { jsx as _jsx } from "react/jsx-runtime";
var Icon = function Icon(_ref) {
  var icon = _ref.icon,
    className = _ref.className,
    style = _ref.style;
  var isReactIcon = icon && icon.startsWith('ri-');
  if (isReactIcon) {
    return /*#__PURE__*/_jsx(ReactIcon, {
      icon: icon,
      className: className,
      style: style
    });
  } else {
    return /*#__PURE__*/_jsx(PantherIcon, {
      icon: icon,
      className: className,
      style: style
    });
  }
};
Icon.propTypes = {
  icon: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object
};
export default Icon;